import {getFetch, API_SERVERLESS} from '~commonApi';

export function apiPublicSearchApplicationDetails(applicationNumber) {
    return getFetch(`${API_SERVERLESS}/mypvr/v3/publicSearchApplicationDetails/${applicationNumber}`, false);
}

export function apiPublicSearchDenomination(applicationNumber) {
    return getFetch(`${API_SERVERLESS}/mypvr/v3/publicSearchDenominations/${applicationNumber}`, false);
}
